import { settingsAtom } from "@framework/shared/atoms";
import { trans, plainTrans } from "@mongez/localization";
import { isEmpty } from "@mongez/supportive-is";
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhone,
  FaPinterest,
  FaSnapchat,
  FaTiktok,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";

export function ContactInformation() {
  const contactInfo = settingsAtom.use("contact");
  const social = settingsAtom.use("social");

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
          {trans("contactUs")}
        </h3>
        <div className="space-y-4">
          {contactInfo?.phoneNumber && (
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <FaPhone className="text-primary" />
              <a
                href={`tel:${contactInfo.phoneNumber}`}
                className="text-gray-600 hover:text-primary dark:text-gray-400"
              >
                {contactInfo.phoneNumber}
              </a>
            </div>
          )}
          {contactInfo?.whatsappNumber && (
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <FaWhatsapp className="text-primary" />
              <a
                href={`https://wa.me/${contactInfo.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-primary dark:text-gray-400"
              >
                {contactInfo.whatsappNumber}
              </a>
            </div>
          )}
          {contactInfo?.address && (
            <div className="flex items-start space-x-3 rtl:space-x-reverse">
              <FaMapMarkerAlt className="mt-1 text-primary" />
              <span className="text-gray-600 dark:text-gray-400">
                {contactInfo.address}
              </span>
            </div>
          )}
          {contactInfo?.email && (
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <FaEnvelope className="text-primary" />
              <a
                href={`mailto:${contactInfo.email}`}
                className="text-gray-600 hover:text-primary dark:text-gray-400"
              >
                {contactInfo.email}
              </a>
            </div>
          )}
        </div>
      </div>

      {/* Social Media Links */}
      {!isEmpty(social) && (
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
            {trans("socialMedia")}
          </h3>
          <div className="flex flex-wrap items-center gap-4">
            {social?.facebook && (
              <a
                title={plainTrans("footer.facebook")}
                href={social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-600 dark:text-gray-400"
              >
                <FaFacebook size={24} />
              </a>
            )}
            {social?.instagram && (
              <a
                title={plainTrans("footer.instagram")}
                href={social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-600 dark:text-gray-400"
              >
                <FaInstagram size={24} />
              </a>
            )}
            {social?.tiktok && (
              <a
                title={plainTrans("footer.tiktok")}
                href={social.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-red-600 dark:text-gray-400"
              >
                <FaTiktok size={24} />
              </a>
            )}
            {social?.twitter && (
              <a
                title={plainTrans("footer.twitter")}
                href={social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-400 dark:text-gray-400"
              >
                <FaTwitter size={24} />
              </a>
            )}
            {social?.youtube && (
              <a
                title={plainTrans("footer.youtube")}
                href={social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-red-600 dark:text-gray-400"
              >
                <FaYoutube size={24} />
              </a>
            )}
            {social?.linkedIn && (
              <a
                title={plainTrans("footer.linkedIn")}
                href={social.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-700 dark:text-gray-400"
              >
                <FaLinkedin size={24} />
              </a>
            )}
            {social?.snapchat && (
              <a
                title={plainTrans("footer.snapchat")}
                href={social.snapchat}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-yellow-400 dark:text-gray-400"
              >
                <FaSnapchat size={24} />
              </a>
            )}
            {social?.pinterest && (
              <a
                title={plainTrans("footer.pinterest")}
                href={social.pinterest}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-red-700 dark:text-gray-400"
              >
                <FaPinterest size={24} />
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
